import styled, { css } from 'styled-components';
import { ITextProps, A, useTextCss } from '../Texts/Texts';
import { useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import { IInvalidProps } from '../../fundamentals/actions';
import { IColoursCollection } from '../../fundamentals/colours/colourInterfaces';
import { BaseDiv } from '../../common/BaseElements';

export const helpTextColours = ({ text }: IColoursCollection) => ({
  helpTextColours: {
    default: {
      text: text.light
    },
    disabled: {
      text: text.disabled
    },
    invalid: {
      text: text.error
    }
  }
});

export interface IHelpTextProps extends ITextProps, IInvalidProps {
  disabled?: boolean;
}

export const HelpText = styled(BaseDiv).attrs<IHelpTextProps>(({ textEoraSize = 'SMALL', textStyle = 'REGULAR', ...rest }) => ({
  textEoraSize,
  textStyle,
  ...rest
}))<IHelpTextProps>`
  &,
  && * {
    ${useTextCss}
  }

  ${({ disabled, invalid, theme }) => css`
    color: ${invalid ? theme.helpTextColours.invalid.text : theme.helpTextColours[disabled ? `disabled` : `default`].text};
    & *:not(${A}) {
      color: ${invalid ? theme.helpTextColours.invalid.text : theme.helpTextColours[disabled ? `disabled` : `default`].text};
    }
  `}

  ${useGutterAsMarginCss()};
`;
